__turbopack_context__.v({
  "buttons": "_9x4tna_buttons",
  "fullpagewrapper": "_9x4tna_fullpagewrapper",
});
